<template>
  <div v-if="loading" :data-testid="dataTestid ? `${dataTestid}-loading` : undefined" class="animate-pulse space-y-3" aria-hidden="true">
    <div class="h-4 w-1/3 rounded-sm bg-surface-elevation-2" />
    <div class="rounded-lg bg-surface-elevation-2" :class="skeletonHeightClass" />
  </div>

  <div
    v-else-if="state === 'error'"
    :data-testid="dataTestid ? `${dataTestid}-error` : undefined"
    class="flex items-center justify-center gap-2 py-8 text-error"
  >
    <AlertTriangleIcon class="lucide-icon-s shrink-0" aria-hidden="true" />
    <span class="txt-body-s-regular">{{ t('Reviews.product.insights.state.error') }}</span>
  </div>

  <InsightsEmptyState v-else-if="state !== 'ready'" :state="state" :data-testid="dataTestid ? `${dataTestid}-empty` : undefined" />

  <slot v-else />
</template>

<script setup lang="ts">
import { AlertTriangleIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { InsightsMetricState } from '@/gql/reviews/mappers/insights/insightsState'

import InsightsEmptyState from './InsightsEmptyState.vue'

const props = withDefaults(
  defineProps<{
    state: InsightsMetricState
    loading?: boolean
    skeleton?: 'chart' | 'compact'
    dataTestid?: string
  }>(),
  { loading: false, skeleton: 'chart', dataTestid: undefined },
)

const { t } = useI18n()

const skeletonHeightClass = computed(() => (props.skeleton === 'compact' ? 'h-16' : 'h-48'))
</script>
